import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'polygon'),
  es: flattenMessages(es, 'polygon'),
  ru: flattenMessages(ru, 'polygon'),
  zh: flattenMessages(zh, 'polygon'),
};
